// import { createRouter, createWebHashHistory } from 'vue-router';
// import request from '@/utils/request';
// // import { useRouterStore } from '@/store/routerStore';
// // const useRouterEvent = useRouterStore();

// const routes = [
//   {
//     path: '/',
//     name: 'Login',
//     component: () => import('@/views/login.vue'),
//   },
//   {
//     path: '/home',
//     name: 'home',
//     component: () => import('@/views/home.vue'),
//   },
//   {
//     path: '/404',
//     component: () => import('@/views/404.vue'),
//   },
// ];

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes,
// });
// let dynamicRouteNames = [];

// let data = [];
// // const notFoundRouter = {
// //   path: '/:pathMatch(.*)*',
// //   redirect: '/404',
// //   hidden: true,
// // };

// let testData1 = [
//   {
//     Children: [
//       { Type: 1, Url: '/Home/Dashboard', path: '/Home/Dashboard' },
//       {
//         Type: 1,
//         Url: '/MM_Manage/MM_MARBP/ListX',
//         path: '/MM_Manage/MM_MARBP/ListX',
//       },
//     ],
//   },
// ];

// /**
//  * 获取后端路由信息的 axios API
//  * @returns {Promise}
//  */
// export const getRouterByUser = () => {
//   return new Promise((resolve, reject) => {
//     // addRoutesFromMenuData(testData1);
//     request
//       .post('/Base_Manage/Home/GetOperatorMenuList', {})
//       .then((resJson) => {
//         if (resJson.Success) {
//           data = resJson.Data;
//           addRoutesFromMenuData(resJson.Data);
//         }
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };
// getRouterByUser();

// function generateRoutesFromMenuData(menuData) {
//   const newRoutes = [];
//   menuData.forEach((item) => {
//     if (item.Children) {
//       item.Children.forEach((child) => {
//         if (child.path) {
//           const route = {
//             path: child.path,
//             name: child.path.replace(/\//g, '_').substring(1),
//             // 修复组件路径：确保路径以斜杠开头，如 /MM_Manage/MM_MARBP/ListX
//             component: () => import(`@/views${child.path}.vue`),
//           };
//           newRoutes.push(route);
//         }
//       });
//     }
//   });
//   return newRoutes;
// }

// // 动态添加路由的函数
// function addRoutesFromMenuData(menuData) {
//   return new Promise((resolve) => {
//     // if (isRoutesAdded) return resolve(); // 防止重复添加
//     // isRoutesAdded = true;

//     const newRoutes = generateRoutesFromMenuData(menuData);
//     newRoutes.forEach((route) => {
//       router.addRoute(route);
//     });

//     // router.addRoute(notFoundRouter);

//     // 确保所有路由添加完成后再 resolve
//     resolve();
//   });
// }
// // // 动态添加路由的函数
// // function addRoutesFromMenuData(menuData) {
// //   return new Promise((resolve) => {
// //     // if (isRoutesAdded) return resolve(); // 防止重复添加
// //     // isRoutesAdded = true;
// //     dynamicRouteNames = [];
// //     const newRoutes = generateRoutesFromMenuData(menuData);
// //     newRoutes.forEach((route) => {
// //       router.addRoute(route);
// //       dynamicRouteNames.push(route);
// //     });
// //     console.log('newRoutes2', newRoutes);
// //     console.log('dynamicRouteNames2', dynamicRouteNames);

// //     console.log('smsm', router.getRoutes());

// //     // router.addRoute(notFoundRouter);

// //     // 确保所有路由添加完成后再 resolve
// //     resolve();
// //   });
// // }

// // // 清空动态路由的函数
// // export const clearDynamicRoutes = () => {

// // };

// // 修改后的清空路由函数
// export const clearDynamicRoutes = () => {
//   console.log('dynamicRouteNames', dynamicRouteNames);

//   // dynamicRouteNames.forEach(name => {
//   //   router.removeRoute(name)
//   // })
//   // dynamicRouteNames = []

//   // // 重置到初始路由（可选）
//   // router.getRoutes().forEach(route => {
//   //   if (!routes.some(r => r.path === route.path)) {
//   //     router.removeRoute(route.name)
//   //   }
//   // })
// };

// // 在合适的时机调用动态添加路由的函数，例如在路由初始化之后
// addRoutesFromMenuData(data);

// export default router;

// 以上是正常的

// 测试
import { createRouter, createWebHashHistory } from 'vue-router';
import request from '@/utils/request';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/login.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home.vue'),
  },
  {
    path: '/AboutView',
    component: () => import('@/views/AboutView.vue'),
  },
  {
    path: '/PS_Manage/PS_OPDC/OPDC',
    component: () => import('@/views/PS_Manage/PS_OPDC/OPDC.vue'),
  },
  {
    path: '/PS_Manage/PS_OPDC/IPQC',
    component: () => import('@/views/PS_Manage/PS_OPDC/IPQC.vue'),
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

let data = [];
let dynamicRoutes = []; // 用于存储动态添加的路由

let testData1 = [
  {
    Children: [
      { Type: 1, Url: '/Home/Dashboard', path: '/Home/Dashboard' },
      {
        Type: 1,
        Url: '/MM_Manage/MM_MARBP/ListX',
        path: '/MM_Manage/MM_MARBP/ListX',
      },
    ],
  },
];

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export const getRouterByUser = () => {
  return new Promise((resolve, reject) => {
    request
      .post('/Base_Manage/Home/GetOperatorMenuList', {})
      .then((resJson) => {
        if (resJson.Success) {
          data = resJson.Data;
          addRoutesFromMenuData(resJson.Data);
          resolve(resJson.Data);
          // console.log('路由获取', router.getRoutes());
        }
        // else {
        //   reject(new Error('请求失败'));
        // }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

function generateRoutesFromMenuData(menuData) {
  const newRoutes = [];
  menuData.forEach((item) => {
    if (item.Children) {
      item.Children.forEach((child) => {
        if (child.path) {
          const route = {
            path: child.path,
            name: child.path.replace(/\//g, '_').substring(1),
            component: () => import(`@/views${child.path}.vue`),
          };
          newRoutes.push(route);
        }
      });
    }
  });
  return newRoutes;
}

// 动态添加路由的函数
function addRoutesFromMenuData(menuData) {
  return new Promise((resolve) => {
    const newRoutes = generateRoutesFromMenuData(menuData);
    newRoutes.forEach((route) => {
      router.addRoute(route);
      dynamicRoutes.push(route); // 存储动态添加的路由
    });
    resolve();
  });
}

// 清空动态路由的函数
export const clearDynamicRoutes = () => {
  dynamicRoutes.forEach((route) => {
    const name = route.name;
    if (name) {
      router.removeRoute(name);
    }
  });
  dynamicRoutes = []; // 清空存储的动态路由数组
};

getRouterByUser();

export default router;
